import { TRANSLATIONS_STORAGE_KEY } from '@constants/Translations';
import { cookies } from '@utils/cookies';

const loadVanillaTranslations = async (): Promise<Record<string, string>> => {
    const locale = cookies.get<string>('locale') || 'en';

    try {
        const rawTranslations = sessionStorage.getItem(TRANSLATIONS_STORAGE_KEY);
        if (rawTranslations) {
            const cache = JSON.parse(rawTranslations) as Record<
                string,
                { etag: string; translations: Record<string, string> }
            >;
            if (cache[locale]?.translations) {
                return cache[locale].translations;
            }
        }
    } catch {
        // sessionStorage unavailable or corrupt — fall through to fetch
    }

    try {
        const response = await fetch(`/static/build/lang/${locale}.json`);
        if (response.ok) {
            return await response.json();
        }
    } catch {
        // Network unavailable or parse error — fall through to empty
    }

    return {};
};

export { loadVanillaTranslations };
